import React from 'react';
import { Global, css } from '@emotion/react';
import Tippy from '@tippyjs/react';
import 'tippy.js/themes/light-border.css';
import 'tippy.js/themes/light.css';
import 'tippy.js/dist/tippy.css';

import { Theme } from '../theme';

const defaultProps = {
  content: <div>PopoverContent</div>,
  children: <button>Button</button>,
};

const Popover = (props) => {
  const { children, arrow = true } = props;
  const styleOptions = {
    theme: props.theme || 'light-border',
    arrow,
    maxWidth: 600,
    animation: 'shift-away',
    duration: [100, 50],
    trigger: 'click',
    interactive: true,
    popperOptions: {
      positionFixed: true,
    },
    inertia: true,
    flip: false,
    appendTo: 'parent',
  };

  return (
    <>
      <Global
        styles={css`
          .tippy-box {
            padding: 0;
          }
          [data-tippy-root] {
            outline: 0;
          }
        `}
      />
      <Tippy {...styleOptions} {...props}>
        {children}
      </Tippy>
    </>
  );
};

Popover.defaultProps = defaultProps;
export default Popover;
